
import {
  TimePicker,
  Flex,
  Select as SelectAntd,
  SelectProps,
  InputProps,
  Input as InputAntd,
} from 'antd';
import styled from 'styled-components';
import React from 'react'
import _ from 'lodash'
import { LoadingOutlined } from '@ant-design/icons'


const defaultFilterOptionFn:SelectProps['filterOption'] = (input, option) =>{
  return (option?.label?.toString() || '').toLowerCase().includes(input.toLowerCase())
}
export interface FilterSelectPcProps extends Omit<SelectProps,'children'>  {
  defaultFilterOption?:boolean,
  getInitData?():void
  singleMode?: boolean
}


export const FilterSelectPc = (props: FilterSelectPcProps ) => {
  const { defaultFilterOption,getInitData,onSearch,singleMode, value, ...reset } = props;
  let filterOption = props.filterOption
  if(defaultFilterOption){
    filterOption = defaultFilterOptionFn
  }
  if (onSearch) {
    filterOption = false
  }
  if(singleMode){
    delete reset.mode
  }
  React.useEffect(()=>{
    if(reset.mode){
      let hasArrayValue = Array.isArray(props.value) && props.value.length
      if (!props.value || !hasArrayValue) {
        return
      }
    }else{
      if(props.value === undefined || props.value === null || props.value === ''){
        return 
      }
    }
    
    setTimeout(()=>{
      props.getInitData && props.getInitData()
    },300)
  },[])
  const refDebounce = React.useRef(_.debounce((val)=>{
    onSearch && onSearch(val)
  },300,{trailing:true}))
  const onSearchInternal = (val:string)=>{
    refDebounce.current(val) 
  }
  let valueInternal =  value

  return (
    <SelectAntd
      onSearch={onSearchInternal}
      showSearch={!!defaultFilterOption}
      allowClear
      notFoundContent={ props.loading ? <LoadingOutlined /> : null }
      style={{ width: '100%' }}
      onFocus={getInitData}
      value= { singleMode && Array.isArray(valueInternal) ? valueInternal[0] : valueInternal }
      {...reset}
      filterOption={filterOption}
    />
  );
}